import {
  Table,
  Tbody,
  Td,
  Tr,
  Flex,
  Image,
  Spinner,
  Box,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOrderHistory } from "../Redux/App/action";
import { useNavigate } from "react-router-dom";
import { BsCartX, BsArrowRight } from "react-icons/bs";

const Orders = () => {
  const dispatch = useDispatch();
  const { allOrders, isLoading } = useSelector((store) => store.appReducer);
  useEffect(() => {
    dispatch(getOrderHistory);
  }, [dispatch]);

  const navigate = useNavigate();

  const Loader = () => {
    return (
      <Box
        position="fixed"
        top="0"
        left="0"
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        background="rgba(0, 0, 0, 0.5)"
        zIndex="9999"
      >
        <Spinner size="xl" color="blue.500" thickness="4px" />
      </Box>
    );
  };
  if (isLoading) {
    return (
      <Box h={"80vh"}>
        <Loader />
      </Box>
    );
  }

  if (allOrders?.length === 0) {
    return (
      <div className="my-8 mt-28 flex flex-col justify-center text-center  justify-items-center ">
        <div className="mx-auto">
          <BsCartX size={60} color="#3c375f" />
        </div>
        <div className="mt-2 mb-1 text-bas ">
          <p className="font-medium">It looks like you haven't shopped yet</p>
        </div>

        <div className="mb-3">
          Let's Start Shopping <BsArrowRight size={20} className="inline" />
        </div>

        <div>
          <button
            className="relative inline-flex items-center justify-center p-0.5 mb-2 me-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-purple-600 to-blue-500 group-hover:from-purple-600 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800"
            onClick={() => {
              navigate("/homeDecorAll");
            }}
          >
            <span className="relative px-3 py-1.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
              Home Decor
            </span>
          </button>
          <button
            className="relative inline-flex items-center justify-center p-0.5 mb-2 me-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-cyan-200 dark:focus:ring-cyan-800"
            onClick={() => {
              navigate("/potsAll");
            }}
          >
            <span className="relative px-3 py-1.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
              Pots
            </span>
          </button>
          <button
            className="relative inline-flex items-center justify-center p-0.5 mb-2 me-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-green-400 to-blue-600 group-hover:from-green-400 group-hover:to-blue-600 hover:text-white dark:text-white focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800"
            onClick={() => {
              navigate("/plantEcommerce");
            }}
          >
            <span className="relative px-3 py-1.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
              Plants
            </span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <Flex
      w="full"
      p={{ md: 5, base: 0 }}
      alignItems="center"
      justifyContent="center"
    >
      <Table
        w="full"
        display={{
          base: "block",
          md: "table",
        }}
        sx={{
          "@media print": {
            display: "table",
          },
        }}
      >
        <Tbody
          display={{
            base: "block",
            lg: "table-row-group",
          }}
          sx={{
            "@media print": {
              display: "table-row-group",
            },
          }}
        >
          {allOrders?.map((element) => {
            return element.orderItemsDetailResponse.map((order, i) => {
              return (
                <Tr
                  key={i}
                  display={{
                    base: "grid",
                    md: "table-row",
                  }}
                  sx={{
                    "@media print": {
                      display: "table-row",
                    },
                    gridTemplateColumns: "minmax(0px, 35%) minmax(0px, 65%)",
                    gridGap: "10px",
                  }}
                  bg={"white"}
                  onClick={() => {
                    localStorage.setItem("orderId", element.orderId);
                    navigate("/Cart/OrderDetails");
                  }}
                  cursor={"pointer"}
                >
                  <Td
                    display={{
                      base: "table-cell",
                      md: "none",
                    }}
                    sx={{
                      "@media print": {
                        display: "none",
                      },
                      textTransform: "uppercase",

                      fontSize: "xs",
                      fontWeight: "bold",
                      letterSpacing: "wider",
                      fontFamily: "heading",
                    }}
                  ></Td>
                  <Td
                    fontSize="md"
                    fontWeight="hairline"
                    w={{ md: "10%", base: "80%" }}
                  >
                    <Image src={order.imageUrl} borderRadius={10} />
                  </Td>
                  <Td
                    display={{
                      base: "table-cell",
                      md: "none",
                    }}
                    sx={{
                      "@media print": {
                        display: "none",
                      },
                      textTransform: "uppercase",

                      fontSize: { md: "xs", base: "10px" },
                      fontWeight: "bold",
                      letterSpacing: "wider",
                      fontFamily: "heading",
                    }}
                  >
                    PRODUCT NAME
                  </Td>
                  <Td fontSize="md" fontWeight="hairline">
                    {order.productName}
                  </Td>
                  <Td
                    display={{
                      base: "table-cell",
                      md: "none",
                    }}
                    sx={{
                      "@media print": {
                        display: "none",
                      },
                      textTransform: "uppercase",

                      fontSize: { md: "xs", base: "10px" },
                      fontWeight: "bold",
                      letterSpacing: "wider",
                      fontFamily: "heading",
                    }}
                  >
                    QUANTITY
                  </Td>
                  <Td fontSize="md" fontWeight="hairline">
                    {order.quantity}
                  </Td>
                  <Td
                    display={{
                      base: "table-cell",
                      md: "none",
                    }}
                    sx={{
                      "@media print": {
                        display: "none",
                      },
                      textTransform: "uppercase",

                      fontSize: { md: "xs", base: "10px" },
                      fontWeight: "bold",
                      letterSpacing: "wider",
                      fontFamily: "heading",
                    }}
                  >
                    PRICE
                  </Td>
                  <Td fontSize="md" fontWeight="hairline">
                    {order.totalPrice}
                  </Td>
                  <Td
                    display={{
                      base: "table-cell",
                      md: "none",
                    }}
                    sx={{
                      "@media print": {
                        display: "none",
                      },
                      textTransform: "uppercase",

                      fontSize: { md: "xs", base: "10px" },
                      fontWeight: "bold",
                      letterSpacing: "wider",
                      fontFamily: "heading",
                    }}
                  >
                    Order Status
                  </Td>
                  <Td fontSize="md" fontWeight="hairline">
                    {element.orderStatus}
                  </Td>
                </Tr>
              );
            });
          })}
        </Tbody>
      </Table>
    </Flex>
  );
};

export default Orders;
